/**
 * @generated SignedSource<<fab1db2686effbe22765b206861d2074>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type client_type = "BEACON" | "DOCK" | "EXTERNAL_RADIO" | "JOYSTICKS" | "MISSION_CONDUCTOR" | "MOBILE" | "SCHEDULER" | "SKYSTICKS" | "UNKNOWN" | "VEHICLE" | "WEB" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type FlightsList_flight$data = {
  readonly dataFiles: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly kind: string;
        readonly " $fragmentSpreads": FragmentRefs<"FileCard_file">;
      } | null;
    } | null>;
  } | null;
  readonly dock: {
    readonly displayName: string;
    readonly dockId: string;
    readonly id: string;
  } | null;
  readonly hasTelemetry: boolean | null;
  readonly id: string;
  readonly organization: {
    readonly id: string;
    readonly name: string;
    readonly uuid: string;
  } | null;
  readonly takeoffClientType: client_type;
  readonly takeoffLocation: {
    readonly latitude: number | null;
    readonly longitude: number | null;
  } | null;
  readonly user: {
    readonly displayName: string | null;
    readonly email: string;
    readonly id: string;
  } | null;
  readonly uuid: string;
  readonly vehicle: {
    readonly displayName: string;
    readonly id: string;
    readonly vehicleId: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"FlightAnnotations_flight" | "useFlightDuration_fragment">;
  readonly " $fragmentType": "FlightsList_flight";
};
export type FlightsList_flight$key = {
  readonly " $data"?: FlightsList_flight$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightsList_flight">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightsList_flight",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        },
        {
          "kind": "Literal",
          "name": "kinds",
          "value": [
            "VEHICLE_VIDEO_RAW",
            "VEHICLE_VIDEO_PREVIEW",
            "VEHICLE_IMAGE",
            "VEHICLE_IMAGE_DNG",
            "VEHICLE_IR_IMAGE",
            "VEHICLE_RADIOMETRIC_IMAGE"
          ]
        }
      ],
      "concreteType": "FlightDataFileConnection",
      "kind": "LinkedField",
      "name": "dataFiles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FlightDataFileEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FlightDataFile",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "kind",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "FileCard_file"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "dataFiles(first:1,kinds:[\"VEHICLE_VIDEO_RAW\",\"VEHICLE_VIDEO_PREVIEW\",\"VEHICLE_IMAGE\",\"VEHICLE_IMAGE_DNG\",\"VEHICLE_IR_IMAGE\",\"VEHICLE_RADIOMETRIC_IMAGE\"])"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFlightDuration_fragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FlightAnnotations_flight"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasTelemetry",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "takeoffClientType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Location",
      "kind": "LinkedField",
      "name": "takeoffLocation",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "latitude",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "longitude",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Vehicle",
      "kind": "LinkedField",
      "name": "vehicle",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vehicleId",
          "storageKey": null
        },
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Dock",
      "kind": "LinkedField",
      "name": "dock",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dockId",
          "storageKey": null
        },
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Flight",
  "abstractKey": null
};
})();

(node as any).hash = "81a0d1bdb98e0c99a7e496942134837d";

export default node;
